import { Seo } from "@/components/Seo";
import { BookingWizard } from "@/components/booking/BookingWizard";
import { FadeUp, Lines } from "@/components/motion/Reveal";
import { company } from "@/data/site";

export default function Termin() {
  return (
    <>
      <Seo title="Termin anfragen" description="Terminanfrage in sechs Schritten: Fahrzeug, Service, Anliegen, Wunschtermin, Kontakt. Wir bestätigen persönlich – eine Anfrage ist noch keine Buchung." />
      <section className="pt-32 md:pt-44 pb-10 md:pb-14">
        <div className="container-x flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <FadeUp><p className="eyebrow mb-6">Terminanfrage</p></FadeUp>
            <Lines as="h1" lines={["Termin", "anfragen."]} className="h-display" data-testid="page-title" />
          </div>
          <FadeUp delay={0.2} className="text-[color:var(--ink-2)] max-w-sm md:text-right">
            Lieber direkt? <a href={company.phoneHref} className="text-[color:var(--ink)] link-underline" data-testid="termin-phone-link">{company.phone}</a>
            <br />Eine Anfrage ist noch keine Buchungsbestätigung.
          </FadeUp>
        </div>
      </section>
      <section className="pb-28 md:pb-40">
        <div className="container-x">
          <FadeUp delay={0.1}><BookingWizard /></FadeUp>
        </div>
      </section>
    </>
  );
}
